// A "memberUpdated" event (shared/src/protocol.ts MemberProfile) applied to the open server's member list: the person's new name, avatar and
// name color show everywhere at once, with no refetch (#631, #698). A color the event leaves out keeps the one the list has.
import type { Member, MemberProfile } from "@bloom/shared";

export function applyProfile(list: readonly Member[], p: MemberProfile): Member[] {
  return list.map((m) => (m.id === p.id ? { ...m, name: p.name, image: p.image, nameColor: p.nameColor !== undefined ? p.nameColor : m.nameColor } : m));
}
